import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { Button, Swipe, SwipeItem, Icon, Circle, Lazyload, Toast, Loading, Dialog, Field, CellGroup, Progress, Sticky, RadioGroup, Radio } from 'vant';
import '@vant/touch-emulator';
import loading from '@/public/components/loading';
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表
import { BarChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import { TitleComponent, TooltipComponent, GridComponent, DatasetComponent, TransformComponent } from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
// 注册必须的组件
echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TransformComponent,
    BarChart,
    LabelLayout,
    UniversalTransition,
    CanvasRenderer
]);
const docCookies = require('@/public/utils/cookies');
require('@/assets/js/rem.ts');
// 路由拦截
router.beforeEach((to, from, next) => {
    if (typeof to.meta.title === 'string') {
        document.title = to.meta.title;
    }
    else {
        document.title = '好医术';
    }
    next();
});
const vmApp = createApp(App);
vmApp.config.globalProperties.$echarts = BarChart;
vmApp.config.globalProperties.docCookies = docCookies;
vmApp.use(loading);
vmApp.use(Icon);
vmApp.use(Lazyload, {
    lazyComponent: true,
    error: 'https://img-a.haoyishu.com/userImg/1676445420756.jpg'
});
vmApp
    .use(Toast)
    .use(Circle)
    .use(Loading)
    .use(Dialog)
    .use(Field)
    .use(CellGroup)
    .use(Progress)
    .use(Sticky)
    .use(RadioGroup)
    .use(Radio);
vmApp.use(Button).use(store).use(Swipe).use(SwipeItem).use(router).mount('#app');
